import React from 'react';
import classnames from 'classnames';
import styles from './contactsList.module.scss';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Contact } from 'v2/models';
import Avatar from 'v2/Avatar/Avatar';
import avatarPersonNoProfilePic from 'v2/images/avatarPersonNoProfilePic.png';
import angleIcon from '../../icons/angle.svg';
import { getContactNameToDisplay } from 'v2/utils/ContactUtils';
import { useTranslation } from 'react-i18next';
import { PostProcessKeys, TranslationKeys } from 'translations';
interface ContactsListProps {
  list: Contact[] | undefined;
}

const ContactsList = ({ list }: ContactsListProps) => {
  const { t } = useTranslation();

  return (
    <div className={classnames('position-relative', styles.tableContainer)}>
      <div>
        <div
          className={classnames(styles.tableHeader, styles.columnStyle)}
          data-cy="contacts-list:contacts-list-headers"
        >
          <p className="pr-1 pl-1">{t(TranslationKeys.contact_one)} Name</p>
          <p className="pr-1 pl-1">{t(TranslationKeys.company_one)}</p>
          <p className="pr-1 pl-1">Email</p>
        </div>
        {!list?.length && (
          <div
            className={styles.NoDataContent}
            data-cy="contacts-list:contacts-list-empty-page"
          >
            <hr></hr>
            <h1>No {t(TranslationKeys.contact_other)} have been added yet!</h1>
          </div>
        )}
        {list?.map((item, index) => (
          <Link
            key={item.id}
            className="text-decoration-none"
            role="listitem"
            data-cy={`contact:list-item-${index}`}
            to={{
              pathname: `/contact-details/${item.id}/detail`,
              state: {
                counterToGoBack: -1,
                backLinkTitle: t(TranslationKeys.contact_other, {
                  postProcess: PostProcessKeys.TitleCase,
                }),
              },
            }}
          >
            <Card className="mb-3">
              <Card.Body className={classnames(styles.rowBody)}>
                <div
                  className={classnames(styles.tableRow, styles.columnStyle)}
                >
                  <div className="d-flex">
                    <Avatar
                      url={item.avatar_url || avatarPersonNoProfilePic}
                      className={classnames('mr-2', styles.contactAvatar)}
                    />
                    <div className={classnames(styles.nameContainer)}>
                      <p className={classnames(styles.contactName)}>
                        {getContactNameToDisplay(item)}
                      </p>
                      <p>{item.title}</p>
                    </div>
                  </div>
                  <p>{`${
                    item.primary_associations.data_vendor?.name ||
                    item.company_name ||
                    ''
                  }`}</p>
                  <p>{`${item.primary_associations.email?.email}`}</p>
                  <div className={classnames(styles.nextLink)}>
                    <img src={angleIcon} alt="angleIcon"></img>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ContactsList;
